import {Generic3DModel} from "../models/generic-3D-model";
import {Mesh, MeshPhysicalMaterial, MeshStandardMaterial, Object3D} from "three";
import {ResourceManagerService} from "../service/resource.manager.service";
import {Features} from "../decorators/features.decorator";
import {Movable} from "../models/feature/movable.feature";
import {CustomMaterialType} from "../service/material/custom-material-type.enum";
import {MaterialService} from "../service/material/material.service";
import {dispose3dResource} from "../util/dispose-object";
import {ColorInfo} from "../../core/util/color-converter";


@Features(Movable)
export class FrameProfileObject extends Generic3DModel<Object3D> {
    readonly data: any;  // init data
    model: Object3D | undefined;

    constructor(

        data: any,
        private resourceManager: ResourceManagerService,
        private materialService: MaterialService

    ) {
        super("FrameProfileObject");
        this.data = data; // hox. osoittaa vain rakennustilanteen datan
    }

    /**
     * Kutsutaan erikseen, jotta voimme odottaa asynkronista latausta
     */
    public async init(): Promise<void> {

        this._object.receiveShadow = true;
        this._object.castShadow = true;

        const modelPath = "/api/storage/view/"+this.data.object3dUrl

        try {

            return this.loadModel(modelPath);

        } catch (error) {

            console.error(`Failed to load model:`, error);

        }
    }

    private async loadModel(path: string): Promise<void> {

        return this.resourceManager.loadResource(

            path,
            "obj",
            this.data.uuid,
            true

       ).then( async (model)=> {

            if (model instanceof Object3D) {

                this.model = model;
                this._object.add(model);
                this._object.scale.set(1,(this.data.length/1000),1) // Set profile length

                const materialTypeEnum = this.data.materialType === "Powder Coated" ? CustomMaterialType.PowderCoated : CustomMaterialType.AnodizedAluminum;
                const color = this.data.color
                return this.applyMaterialAndColor(materialTypeEnum, color, model);

            } else {

                console.warn(`Model ${path} not loaded correctly`);

            }

        }).catch(console.error);
    }

    //init function uses model attribute since async
    public async applyMaterialAndColor(material: CustomMaterialType, color: ColorInfo, model?: Object3D): Promise<void> {
        try {

            this.data.color = color; //TODO: unwrap data attribute.

            return this.materialService.getMaterial(material).then((material) => {

                (model || this._object).traverse((node) => {

                    if (node instanceof Mesh) {
                        (material as MeshPhysicalMaterial).color.set(color.HEX);
                        node.material = material;
                    }

                });

            })

        } catch (error) {
            console.error('Virhe materiaalin haussa: ', error);
        }

    }

    public object(): Object3D {
        return this._object;
    }

    setColor(color: ColorInfo) {

        this.data.color = color; //TODO: remove data attribute to not confuse yourself

        this._object.traverse((node) => {
            if (node instanceof Mesh && node.material instanceof MeshStandardMaterial ) { node.material.color.set(color.HEX) }
        })

    }

    public override destroy(): void {
        delete this.materialService;
        delete this.resourceManager;

        dispose3dResource(this._object);

        delete this.model;
        delete this._object;

        this.destroyed.next();
    }

}
